import { getAppCfg } from "../core/app-cfg";
import { EDITOR_VIEW_NAME } from "../core/constants";
import { getProjectUrl } from "../core/project/projectid";
import { getDomainCfg } from "../core/state";
import { getViewData } from "../core/views";
import { userHasRoleFromList } from "./cloudstorage/user";
import { fillUserCodeIntoTemplate } from "./coderunner";
import { getFileContent, getJson } from "./http";
import { getEditorContent, getEditorContentFromTab } from "./tabs";
import { getProjectFromTemplateDefinition } from "./templates";
import { createZipFile } from "./zipping";

export function isExportAvailable() {
  const project = getViewData(EDITOR_VIEW_NAME).project;
  if (!getDomainCfg().viewSettings.features.exportAvailable) return false;

  const exportUserRoles = getDomainCfg().viewSettings.features.exportUserRoles;
  if (exportUserRoles && !userHasRoleFromList(exportUserRoles)) return false;

  // V2-Projekte: kein Manifest noetig, Export geht direkt ueber VFS/Tabs
  if (project?.version === "2.0") return true;

  return !!project?.manifest;
}

export async function exportProjectAsZip() {
  const state = getViewData(EDITOR_VIEW_NAME);
  console.log("export project as zip:", state)
  if (!state.project?.manifest) {
    return;
  }
  
  // Load manifest if it's a string reference
  let manifest = state.project.manifest;
  if (typeof manifest === 'string') {
    manifest = await getJson(getDomainCfg().projectSettings.projectUrl + '/' + manifest);
  }
  
  // Add content from editor
  if (manifest.type === undefined) {
    createCompiledProject(state);
  } else if (manifest.type === "template") {
    await createTemplateProject(state, manifest);
  }

}

async function createCompiledProject(state) {
  const projectFiles = await createTemplateFiles(state);
  const userFiles = addUserCode(state);
  const files = projectFiles.concat(userFiles);

  createZipFile("project.zip", files);
}

async function createTemplateProject(state, manifest) {
  const files = [];
  console.log("save template project", manifest);
  const manifestFiles = manifest.files;
  
  if (!manifestFiles || manifestFiles.length === 0) {
    console.error("No files in manifest");
    return;
  }
  
  for (let i =0; i < manifestFiles.length; i++) {
    const mFile = manifestFiles[i];
    let content = "";
    
    if (mFile.type == "file") {
      const projectId = getAppCfg().projectId;
      const url =  getProjectUrl(getDomainCfg(), projectId) + "/" + mFile.name
      console.log("save file", url);
      content = await getFileContent(url);
    } else if (mFile.type == "Init") {      
      content = getEditorContentFromTab(mFile.type);
    } else if (mFile.type == "Code") {      
      content = getEditorContentFromTab(mFile.type);
      // Fallback: use editorCode from state if tab content is empty
      if (!content || content.trim() === "") {
        content = state.data?.editorCode || state.data?.projectContent?.projectSource || "";
      }
      console.log("got Code content, length:", content ? content.length : 0);
    } else if (mFile.type == "templateproject") {
      //get meta data from template project
      if (mFile.name === "project.json") {
        content = getProjectFromTemplateDefinition();
      }
    }
    
    if (content !== undefined && content !== null) {
      const projectFile = { fileName: mFile.name , content: content};
      files.push(projectFile);
      console.log("added file:", mFile.name);
    } else {
      console.warn("No content for file:", mFile.name, "type:", mFile.type);
    }
  }
  
  if (files.length > 0) {
    console.log("creating zip with", files.length, "files");
    createZipFile("project.zip", files);
  } else {
    console.error("No files to zip!");
  }
}

async function createTemplateFiles(state) {
  // Read manifest file for template, and get each file + content for this project
  const projectFiles = [];

  const data = await getJson(getDomainCfg().projectSettings.projectUrl + '/' + state.project.manifest);
  if (!data.files || data.files.length < 1) {
    return [];
  }

  for (let i =0; i < data.files.length; i++) {
    const file = data.files[i];
    // Only process if file is a string (not an object)
    if (typeof file === 'string') {
      const content = await getFileContent(file);
      const projectFile = { fileName: "app" + file, content};
      projectFiles.push(projectFile);
      console.log("got content for project file, files downloaded:", projectFiles.length);
    }
  }

  if (projectFiles.length === data.files.length) {
    console.log("downloaded all files");
    return projectFiles;
  }

}

function addUserCode(project) {
  // Compile Editor code into template file (like in run) and copy that file into zip...
  const content = fillUserCodeIntoTemplate(project);

  return [{ fileName: "app/index.html", content: replaceAllFirstSlashes(content)}];
}

function replaceAllFirstSlashes(path) {
  return path.replaceAll("/assets", "assets");
}

